import Image from 'next/image';
import { useTranslations } from 'next-intl';

import NaosIcon from '@/fo/icons/base/logos/naos.svg';
import OtzovikIcon from '@/fo/icons/base/logos/otzovik.svg';
import OzonIcon from '@/fo/icons/base/logos/ozon.svg';
import WildberriesIcon from '@/fo/icons/base/logos/wildberries.svg';
import { UiKitTagGroup } from '@/fo/ui/kit/tag/group';
import { UiKitTagToggle } from '@/fo/ui/kit/tag/toggle';

import iRecommendImage from '../../assets/irecommend.webp';
import YaMarketImage from '../../assets/yandex-market-logo.png';
import { ReviewsFilter, TagFilter } from '../../types';

import { styles } from './FilterPanel.styles';

export interface FilterPanelProps {
  filters: ReviewsFilter;
  onFiltersChange: (filters: ReviewsFilter) => void;
}

export function FilterPanel({ filters, onFiltersChange }: FilterPanelProps) {
  const t = useTranslations();

  const slots = styles();

  const handleTagChange = (tags: TagFilter[]) => {
    onFiltersChange({
      ...filters,
      selectedTags: tags
    });
  };

  return (
    <div className={slots.base()}>
      <UiKitTagGroup
        selectionMode="multiple"
        value={filters.selectedTags}
        onSelectionChange={handleTagChange}
        className={slots.tagGroup()}
      >
        <UiKitTagToggle value={TagFilter.WithPhoto}>
          {t('review.filters.withPhoto')}
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.Naos}>
          <NaosIcon className={slots.icon()} />
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.Otzovik}>
          <OtzovikIcon className={slots.icon()} />
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.IRecommend}>
          <Image
            src={iRecommendImage}
            alt="IRecommend"
            className={slots.image()}
            width={188}
            height={32}
          />
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.Ozon}>
          <OzonIcon className={slots.icon()} />
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.Wildberries}>
          <WildberriesIcon className={slots.icon()} />
        </UiKitTagToggle>
        <UiKitTagToggle value={TagFilter.YandexMarket}>
          <Image
            src={YaMarketImage}
            alt="YaMarket"
            className={slots.image()}
            width={188}
            height={32}
          />
        </UiKitTagToggle>
      </UiKitTagGroup>
    </div>
  );
}
